// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading__root___2f2wz"};